import {http} from './api';

export const ShareService = {
  share: (id, model, permissions) => http.post(`share/${id}`, {
    model,
    permissions
  })
};
